export const educationData = [
    {
    id: 1,
    degree: "Secondary School Leaving Certificate (SSLC)",
    institution: "Saradha Vidyalaya Matric Higher Secondary School",
    location: "Tiruppur, India",
    startDate: "2019",
    endDate: "2020",
    percentage: "80.60%",
    description: ""
  },
  {
    id: 2,
    degree: "Higher Secondary Certificate (HSC)",
    institution: "Saradha Vidyalaya Matric Higher Secondary School",
    location: "Tiruppur, India",
    startDate: "2020",
    endDate: "2022",
    percentage: "92.67%",
    description: ""
  },
  {
    id: 3,
    degree: "Bachelor of Engineering in Computer Science and Engineering (AIML)",
    specialization: "Artificial Intelligence and Machine Learning",
    institution: "KPR Institute of Engineering and Technology",
    location: "Coimbatore, India",
    startDate: "2023",
    endDate: "2027",
    cgpa: "9.16",
    description: "Specializing in AI and ML with focus on practical applications and research."
  }
];
